import { create } from "./create"
import { get } from "./get"

export const lifeUsage = {
  get,
  create,
}
